export enum FeatureFlag {
  AccessToRollingOpenEnrollments = 'AccessToRollingOpenEnrollments',
  OEAttachmentEnhancement = 'OEAttachmentEnhancement',
  OEPlanDefaultOptions = 'OEPlanDefaultOptions',
  EnablePlanCategoryNewImplementation = "PlanCategorySearch",
  EnableRetroOENotifications = 'Enable_Retro_OE_Notifications',
  CDB11729Arion = 'CDB11729Arion',
}
